import { Link, useNavigate } from 'react-router-dom';
import { useBabyStore } from '@/stores/useBabyStore';
import { BabyProfileForm } from '@/components/profile/BabyProfileForm';
import { BackLink } from '@/components/ui/PageState';
import { isGerman } from '@/i18n/locale';

export default function AddBaby() {
  const create = useBabyStore((s) => s.create);
  const babies = useBabyStore((s) => s.babies);
  const navigate = useNavigate();
  const de = isGerman();

  const atCap = babies.length >= 3;

  return (
    <div className="min-h-[100dvh] bg-cream flex flex-col">
      <header className="border-b border-primary-50 bg-cream/95 backdrop-blur sticky top-0 z-10">
        <div className="mx-auto max-w-chat px-4 py-3 flex items-center gap-1">
          <BackLink to="/profile" label={de ? 'Zurück zum Profil' : 'Back to profile'} />
          <h1 className="font-display text-lg font-semibold text-slate">
            {de ? 'Baby hinzufügen' : 'Add a baby'}
          </h1>
        </div>
      </header>

      <main className="flex-1 mx-auto max-w-chat w-full px-4 py-6">
        {atCap ? (
          <div className="card p-5 text-center">
            <h2 className="font-display font-semibold text-slate">
              {de ? 'Du hast bereits 3 Babys' : "You're at 3 babies"}
            </h2>
            <p className="text-sm text-slate-muted mt-2">
              {de
                ? 'Alma unterstützt bis zu 3 Baby-Profile pro Konto. Entferne eins im Profil, um ein weiteres hinzuzufügen.'
                : 'Alma supports up to 3 baby profiles per account. Remove one from your profile to add another.'}
            </p>
            <Link to="/profile" className="btn-primary mt-4">
              {de ? 'Zurück zum Profil' : 'Back to profile'}
            </Link>
          </div>
        ) : (
          <section className="card p-5">
            <p className="text-sm text-slate-muted mb-4">
              {de
                ? 'Jedes Baby bekommt eigene altersgenaue Karten, Meilensteine und einen eigenen Chatverlauf.'
                : 'Each baby gets their own age-tuned cards, milestones, and chat history.'}
            </p>
            <BabyProfileForm
              onSubmit={async (values) => {
                await create(values);
                navigate('/today', { replace: true });
              }}
              submitLabel={de ? 'Baby hinzufügen' : 'Add baby'}
              secondaryAction={{
                label: de ? 'Abbrechen' : 'Cancel',
                onClick: () => navigate('/profile'),
              }}
            />
          </section>
        )}
      </main>
    </div>
  );
}
